$(document).ready(function(){

  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    });
  }
  $(".contact-operation").on('click',function() {
    $('html, body').animate({
      'scrollTop' : $(".contact-operation-hours").position().top
    });
  });
  $(".about").on('click',function() {
    $('html, body').animate({
      'scrollTop' : $(".about-nano").position().top
    });
  });
  $(".before").on('click',function() {
    $('html, body').animate({
      'scrollTop' : $(".before-buying-a-device").position().top
    });
  });
  $(".shipping").on('click',function() {
    $('html, body').animate({
      'scrollTop' : $(".ship").position().top
    });
  });
  $(".return").on('click',function() {
    $('html, body').animate({
      'scrollTop' : $(".retu").position().top
    });
  });
  $(".cova").on('click',function() {
    $('html, body').animate({
      'scrollTop' : $(".covid").position().top
    });
  });

  $(".rs-toggle-menu-icon").click(function(){
    $("body").addClass("rs-toggle-menu-main-open");
  });
  $(".rs-toggle-menu-close").click(function(){
    $("body").removeClass("rs-toggle-menu-main-open");
  });
  $(".custmbbd1").click(function(){
    $(this).toggleClass("custminucc");
    $(".custnewsub1").toggleClass("custsubopen");
  });
  $(".custmbbd2").click(function(){
    $(this).toggleClass("custminucc");
    $(".custnewsub2").toggleClass("custsubopen");
  });
  $(".custmbbd4").click(function(){
    $(this).toggleClass("custminucc");
    $(".custnewsub4").toggleClass("custsubopen");
  });

  $(".kk").on('click', function () {
    $(this).toggleClass("faq-active");
  });

  $(".cust-prr-immg").slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  $('ul.tabs').each(function () {
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    $(this).find('a').click(function (e) {
      active.removeClass('active');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  });

  setTimeout(function() {
    $(".template-collection #gorgias-chat-container").show();
  }, 60 * 1000);
});

// product template
$('.featuredPostSlider.show-arrows').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: false,
  adaptiveHeight: true,
  asNavFor: '.product-single_thumbnails',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        dots: true
      }
    }
  ]
});

$('.product-single__thumbnails.dir-vertical').slick({
  infinite: false,
  slidesToShow: 6,
  slidesToScroll: 1,
  focusOnSelect: true,
  asNavFor: '.featuredPostSlide',
  centerMode: false,
  vertical:true,
  verticalSwiping:true,
  arrows: false,
});

$('.featuredPostSlider.hide-arrows').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: false,
  adaptiveHeight: true,
  asNavFor: '.product-single_thumbnails.dir-horizontal',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        dots: true
      }
    }
  ]
});

$('.product-single__thumbnails.dir-horizontal').slick({
  infinite: false,
  slidesToShow: 6,
  slidesToScroll: 1,
  focusOnSelect: true,
  asNavFor: '.featuredPostSlide.hide-arrows',
  centerMode: false,
  vertical:false,
  verticalSwiping:false,
  arrows: false,
});

$('#review_slider_new').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  centerMode: true,
  arrows: false,
  dots:false,
  responsive: [
    {
      breakpoint: 735,
      settings: {
        dots: true,
        slidesToShow: 1,
        arrows: true
      }
    },
    {
      breakpoint: 1024,
      settings: {
        dots: true,
        slidesToShow: 2,
        arrows: true
      }
    }
  ]
}); 

if($('body').hasClass('template-product')) {
  document.querySelector('.product_template_cic_digital_alt_2_new').addEventListener('mediaVisible', function(e) {

    let slickIndex = e.target.dataset.slickIndex;
    $('.featuredPostSlider').slick('slickGoTo', slickIndex, false);
  });
}

var elementTop = document.querySelector('body').scrollTop;
var logoElem = $('.mobsite-header__logo');

if(logoElem.offset().top > 100) {
  $('.MobHdr').addClass('stickied');
}
if(window.scrollY < 50) {
  $('.MobHdr').removeClass('stickied');
}

window.addEventListener('scroll', function() {
  if(logoElem.offset().top > 100) {
    $('.MobHdr').addClass('stickied');
  }
  if(window.scrollY < 50) {
    $('.MobHdr').removeClass('stickied');
  }
});